import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BdAppEnvironmentService } from '@bindoc-projects/platform-lib/data';
import { ApiEndpointKey } from '@bindoc-projects/app-config-domain-lib';
import { BdAdministrativeDistrictId } from '@bindoc-projects/geographic-domain-lib';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class BdStateService {
  private readonly _http = inject(HttpClient);
  private readonly baseUrl: string;

  constructor() {
    const environmentService = inject(BdAppEnvironmentService);
    this.baseUrl = environmentService.load(ApiEndpointKey.BD_DISTRICT_URL);
  }

  public findAdministrativeRegionIds(
    stateIds: number[],
  ): Observable<{ [stateIds: string]: number[] }> {
    const url = `${this.baseUrl}/states/administrative-regions`;
    return this._http.post<{ [stateIds: string]: number[] }>(url, {
      stateIds: stateIds,
    });
  }

  public findCareServiceAreaIds(
    stateIds: number[],
  ): Observable<{ [stateIds: string]: number[] }> {
    const url = `${this.baseUrl}/states/care-service-areas`;
    return this._http.post<{ [stateIds: string]: number[] }>(url, {
      stateIds: stateIds,
    });
  }

  public findAdministrativeDistrictIds(
    stateIds: number[],
  ): Observable<BdAdministrativeDistrictId[]> {
    const url = `${this.baseUrl}/states/administrative-districts`;
    return this._http
      .post<number[]>(url, { stateIds: stateIds })
      .pipe(
        map((response) =>
          response.map((it) => BdAdministrativeDistrictId.createFromNumber(it)),
        ),
      );
  }

  public findPostalCodes(stateIds: number[]): Observable<string[]> {
    const url = `${this.baseUrl}/states/postal-codes`;
    return this._http.post<string[]>(url, { stateIds: stateIds });
  }
}
